import { memo } from "react";
import { Link } from "react-router-dom";
import { MapPin, CheckCircle, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CITIES } from "@/data/citiesData";

export const AreaServedSection = memo(() => (
  <section className="section-padding bg-gradient-to-b from-slate-50 to-white" data-testid="home-area-served-section">
    <div className="container-custom max-w-6xl">
      <div className="text-center mb-10">
        <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">
          <MapPin className="w-4 h-4 mr-1" />
          Zone d&apos;intervention 80 km
        </Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Le spécialiste Apple n°1 à Niort, Deux-Sèvres & rayon 80 km
        </h2>
        <p className="text-lg text-slate-600 max-w-3xl mx-auto">
          Mediastore intervient pour tous les habitants de <strong>Niort 79000</strong>,
          de la <strong>Deux-Sèvres</strong>, et des départements limitrophes
          (Charente-Maritime 17, Vendée 85, Vienne 86) dans un rayon de <strong>80 kilomètres</strong>.
          Meilleur réparateur Apple noté <strong>4,6/5 sur Google</strong> avec 212+ avis vérifiés.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-8">
        {CITIES.map((city) => (
          <Link
            key={city.slug}
            to={`/reparation-${city.slug}`}
            className="flex items-center gap-2 bg-white rounded-lg p-3 shadow-sm border border-slate-100 hover:border-red-200 hover:shadow-md transition-all group"
            data-testid={`area-served-link-${city.slug}`}
          >
            <CheckCircle className="h-4 w-4 text-red-600 flex-shrink-0" />
            <span className="text-sm text-slate-700 font-medium group-hover:text-red-600">{city.name}</span>
            <span className="text-xs text-slate-400 ml-auto">{city.distanceKm} km</span>
          </Link>
        ))}
      </div>

      <div className="text-center">
        <Link to="/villes-desservies">
          <Button size="lg" variant="outline" className="gap-2 border-2" data-testid="see-all-cities-btn">
            Voir toutes les villes desservies
            <ArrowRight className="h-5 w-5" />
          </Button>
        </Link>
        <p className="text-sm text-slate-500 mt-4">
          Et toutes les communes de Deux-Sèvres, Charente-Maritime nord, Vendée sud-est et Vienne ouest dans un rayon de 80 km autour de Niort.
        </p>
      </div>
    </div>
  </section>
));

AreaServedSection.displayName = "AreaServedSection";
